"use client";
import Image from "next/image";
import React from "react";
import PharmaBanner from "../../../public/assets/background/pharma_banner.webp";
import { IoCaretForward } from "react-icons/io5";
import CtbBanner from "../../../public/assets/background/pharma_why_bg.jpg";
import GlassImg from "../../../public/assets/background/pharma_bg.jpg";
import Link from "next/link";
import { HiHome } from "react-icons/hi2";
import { BsPatchCheckFill } from "react-icons/bs";
import { RiMedicineBottleLine } from "react-icons/ri";
import MoreToExploreMobile from "@/components/product/ExploreMoreMobile";
import MoreToExplore from "@/components/product/ExploreMore";
import { FaVial } from "react-icons/fa";
import { GiPill } from "react-icons/gi";
import { MdBiotech } from "react-icons/md";
import PharmaClients from "@/components/product/pharmaClients/PharmaClients";
import PharmaClientsMobile from "@/components/product/pharmaClients/PharmaClientsMobile";
  const categories = [
    {
      title: "Injectable Vials – Transparent & amber options",
      icon: <FaVial className="text-3xl text-red-500" />,
    },
    {
      title: "Syrup & Tonic Bottles – Transparent & amber options",
      icon: <RiMedicineBottleLine className="text-3xl text-red-500" />,
    },
    {
      title: "Pharma & Nutraceutical Packaging",
      icon: <GiPill className="text-3xl text-red-500" />,
    },
    {
      title: "Laboratory & Diagnostic Use",
      icon: <MdBiotech className="text-3xl text-red-500" />,
    },
  ];
const LiquorBottles = () => {
  return (
    <>
      <section className="relative ">
        <div className="grid grid-cols-1 xl:mt-17">
          <Image
            src={PharmaBanner}
            alt="flat-glass"
            className="w-full h-full"
            priority={true}
          />
        </div>
        <div className=" breadcrumb">
          <ul className="flex items-center justify-center gap-2 p-2">
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm gap-1 text-red-600"
              >
                <HiHome />
                Home
              </Link>
            </li>
            <li className="text-sm text-gray-600">/</li>
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm text-gray-400"
              >
                Pharma Bottle
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="xl:py-[50px] pt-[50px] pb-[20px] px-[20px]  xl:mb-5 mb-0">
        <div className="container mx-auto">
          <div className="grid  xl:grid-cols-2  grid-cols-1 gap-5 items-center transition ease-in-out duration-500">
            <div>
               <h2 className="title !text-[#033b6f] !mb-0">
                Trusted <span className="text-[#d42427]"> Glass  </span>
                Packaging
              </h2>
              <h5 className="text-xl  font-semibold">
                for the pharmaceutical industry
              </h5>
             
              <div className="pt-8">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify mb-3 ">
                  In the pharmaceutical sector, packaging plays a critical role
                  in ensuring
                  <span className="font-bold">
                    {" "}
                    purity, accuracy, and safety. At Emerge Glass
                  </span>
                  , we manufacture a wide range of{" "}
                  <strong>
                    transparent and amber glass vials, bottles, and containers{" "}
                  </strong>
                  that meet the demanding standards of pharma companies across
                  India.
                </p>

                <p className="text-sm text-[#003049] font-medium mb-3 leading-6">
                  Every vial and bottle is engineered to maintain the <span className="font-bold">
                    integrity of medicines, vaccines, and sensitive formulations
                  </span>
                  , making Emerge Glass a reliable partner for the healthcare
                  industry.
                </p>
              </div>
            </div>

            <div className="">
              <video
                src="https://www.emergeglass.in/pharma.mp4"
                className="rounded-lg"
                autoPlay
                muted
                loop
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="xl:py-[80px] !pt-[20px] pb-[50px] md:px-0 px-[20px]">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6">
            <div className="order-1 lg:order-2 bg-gradient-to-b from-red-50 to-blue-50 p-6 md:p-8 shadow-2xl h-auto lg:h-[90%]  relative z-40 lg:-ml-[20%] rounded-lg border-b-4 border-red-400 flex flex-col justify-center">
             <h2 className="title !text-[#033b6f] !text-center !text-2xl">
                Our <span className="text-[#d42427]"> Pharma Glass </span>
                Range
              </h2>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Transparent Vials  –
                    </span>
                    <span className="text-[#003049] font-semibold"> For precision storage of injections and formulations
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                     Amber Vials  –
                    </span>
                    <span className="text-[#003049] font-semibold"> Light-resistant vials that protect sensitive medicines
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                     Pharmaceutical Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold">  Reliable packaging for syrups, tonics, and tablets
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Custom Pharma Packaging  –
                    </span>
                    <span className="text-[#003049] font-semibold"> Specialized solutions tailored to pharma needs
                    </span>
                  </p>
                </li>
              </ul>
            </div>

            <Image
              src={GlassImg}
              alt="factory image"
              loading="lazy"
              className="order-2 lg:order-1 rounded-lg relative z-10 w-full h-auto "
            />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden ">
        <Image
          src={CtbBanner}
          alt="call to action banner"
          className="w-full xl:h-[450px] md:h-[400px] h-[500px] object-cover"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/60 z-10"></div>

        <div className="absolute inset-0 xl:w-full w-[92%] xl:left-0 left-1/2 xl:translate-x-0 -translate-x-1/2 flex items-start justify-center z-20 flex-col container mx-auto ">
          <h2 className="xl:text-4xl text-2xl font-bold text-left text-[#fff] mb-5">
            Why Choose Emerge Glass
            <span className="text-red-400"> Pharma Glass?</span>
          </h2>

          <ul className="mt-5 flex flex-wrap justify-center gap-4 text-gray-300 xl:w-[60%]">
            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                 Medical-Grade Purity 
                </span>
                <br />
                Manufactured to meet strict quality standards
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Light Protection 
                </span>
                <br />
                Amber glass shields medicines from harmful UV exposure
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                 Strength & Safety 
                </span>
                <br />
                Durable enough for global distribution
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                 Precision Manufacturing
                </span>
                <br />
                Consistent quality for sensitive formulations
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Sustainable Choice
                </span>
                <br />
                100% recyclable glass for a healthier planet
              </p>
            </li>
          </ul>
        </div>
      </section>

       <section className="py-[50px] px-[20px] bg-white ">
        <div className="container mx-auto">
           <h2 className="title !text-[#033b6f] !text-center">
                Applications
                
              </h2>

         
         

          <ul className="grid xl:grid-cols-4 md:grid-cols-2 gap-8">
      {categories.map((item, index) => (
        <li
          key={index}
           className="group flex items-center gap-4 xl:p-6 p-2 bg-gray-50 rounded-xl border border-gray-200 shadow-sm
                 transition duration-300 ease-out
                 hover:bg-white hover:ring-2 hover:ring-red-200 hover:shadow-md hover:scale-[1.03]"
        >
          <div className="p-3 bg-red-100 rounded-full transition-colors duration-300 group-hover:bg-red-200">{item.icon}</div>
         <p className="text-gray-700 font-medium transition-colors duration-300 group-hover:text-red-600">{item.title}</p>
        </li>
      ))}
    </ul>
        </div>
      </section>
     {/* <section className=" relative bg-gradient-to-b from-white to-[#fbf9f5]">
        <PharmaClients />
        <PharmaClientsMobile />
      </section> */}

      <section className=" py-[50px] xl:pb-[100px] px-4 md:px-0 relative bg-gradient-to-b from-gray-800 to-[#fbf9f5]">
        <div className="">
            <h2 className="title !text-[#fff] !mb-5 !text-center">
          Explore <span className="text-[#d42427]"> More </span>
          Products
        </h2>

          <MoreToExplore/>
          <MoreToExploreMobile />
        </div>
      </section>

     
    </>
  );
};

export default LiquorBottles;
